import { Location } from "vue-router";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import { PaymentPackage, PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { SystemSettings } from "@scrile/api-provider/dist/api/SystemSettingsProvider";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserVerification } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import { OnboardingData } from "@/hooks/useOnboarding/types";
import { StorageItems } from "@/types";
import { GlobalAudioPlayerFileState } from "@/components/GlobalAudioPlayer/types";

export interface StateRoot {
  user: User | null;
  userVerification: UserVerification | null;
  socialLogin: boolean;
  authorities: string[];
  redirectPath: Location | null;
  doNotDisturb: boolean;
  userBalance: number;
  systemSettings: SystemSettings | null;
  creditCardAllowed: boolean;
  publicPaymentSystems: PaymentSystemPublic[];
  creditCards: CreditCardAssignment[];
  darkMode: boolean;
  // undefined until the public information of the logged in user is loaded, null when the user has not set it yet
  dateOfBirth: string | null | undefined;
  mySubscriptionLevels: SubscriptionLevel[] | null;
  paymentPackages: StorageItems<PaymentPackageEnum, PaymentPackage>;
  tags: StorageItems<TagInfoType, TagInfo>;
  globalPlayer: GlobalAudioPlayerFileState | null;
  onboarding: OnboardingData | null;
  hasLocation: boolean;
}
export const state = (): StateRoot => ({
  user: null,
  userVerification: null,
  socialLogin: false,
  authorities: [],
  redirectPath: null,
  doNotDisturb: false,
  userBalance: 0,
  systemSettings: null,
  creditCardAllowed: true,
  publicPaymentSystems: [],
  creditCards: [],
  darkMode: false,
  dateOfBirth: undefined,
  mySubscriptionLevels: null,
  paymentPackages: {},
  tags: {},
  globalPlayer: null,
  onboarding: null,
  hasLocation: false,
});
